/** Load the cold-start destination while Keychain and SQLite I/O are in flight. */
export async function preloadNativeHomeRoute(): Promise<void> {
  await Promise.allSettled([
    import('@/components/mobile/MobileShell'),
    import('@/pages/mobile/mobile-home'),
  ]);
}
